const closeAll = (component) => {
    component.querySelectorAll('[data-house-hotspot]').forEach((hotspot) => {
        hotspot.setAttribute('aria-expanded', 'false');
    });

    component.querySelectorAll('[data-house-popover]').forEach((popover) => {
        popover.hidden = true;
    });
};

const openPopover = (component, slug) => {
    closeAll(component);

    const hotspot = component.querySelector(`[data-house-target="${slug}"]`);
    const popover = component.querySelector(`[data-house-popover="${slug}"]`);

    if (!hotspot || !popover) {
        return;
    }

    hotspot.setAttribute('aria-expanded', 'true');
    popover.hidden = false;
};

const initInteractiveHouse = () => {
    const components = document.querySelectorAll('[data-interactive-house-component]');

    if (!components.length) {
        return;
    }

    components.forEach((component) => {
        component.querySelectorAll('[data-house-hotspot]').forEach((hotspot) => {
            const slug = hotspot.dataset.houseTarget;

            hotspot.addEventListener('mouseenter', () => {
                if (window.matchMedia('(min-width: 992px)').matches) {
                    openPopover(component, slug);
                }
            });

            hotspot.addEventListener('focus', () => {
                openPopover(component, slug);
            });

            hotspot.addEventListener('click', () => {
                const isOpen = hotspot.getAttribute('aria-expanded') === 'true';

                if (isOpen) {
                    closeAll(component);
                    return;
                }

                openPopover(component, slug);
            });
        });

        component.querySelector('.interactive-house-game__scene')?.addEventListener('mouseleave', () => {
            if (window.matchMedia('(min-width: 992px)').matches) {
                closeAll(component);
            }
        });

        document.addEventListener('click', (event) => {
            if (!component.contains(event.target)) {
                closeAll(component);
            }
        });

        component.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAll(component);
            }
        });
    });
};

export default initInteractiveHouse;
